import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationLog } from './async.tsx';

export const IntegrationLog = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIntegrationLog}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
